import React, { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api } from "@/redux/api";
import ContractDetail from "@/containers/contract/ContractDetail";

export default function ContractRequestDetailPage() {
  const { id } = useParams();
  const location = useLocation();

  const listPath = `/contract/contract-request${location.search || ""}`;

  const loadRequest = useCallback(
    (requestId) => api.getContractRequest(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addContractRequestNote(requestId, content),
    []
  );

  return (
    <ContractDetail
      role="contract"
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote
      claim={api.claimContractRequest}
      complete={api.completeContractRequest}
    />
  );
}
